import { FC } from 'react';

import { useApplicationContext } from 'shared/context/ApplicationContext';
import { useCardOfferDataContext } from 'shared/context/CardContext';

import { ChatButtonWideCard } from '../ChatButton';
import { ContactActionsLayout } from '../ContactActionsLayout';
import { JoinElectronicTradingButtonContainer } from '../JoinElectronicTradingButton';
import { PublisherMoreOffersContainer } from '../PublisherMoreOffers';
import { PublisherPhoneButtonContainer } from '../PublisherPhoneButton';

export const ContactActions: FC = () => {
  const { config } = useApplicationContext();
  const { tradingLink } = useCardOfferDataContext();

  /**
   * @todo Удалить фича-тогл
   * @description Данный функционал появился в задаче CD-187914, будет удалён в задаче CD-188067
   */
  const electronicTradingEnabled = config.getStrict<boolean>('Commercial.ElectronicTrading.Enabled');
  const isELectronicTradingAvailable = electronicTradingEnabled && !!tradingLink;

  return (
    <ContactActionsLayout
      chatButton={<ChatButtonWideCard />}
      joinElectronicTradingButton={
        isELectronicTradingAvailable ? (
          <JoinElectronicTradingButtonContainer buttonText="Принять участие в торгах" />
        ) : null
      }
      phoneButton={<PublisherPhoneButtonContainer />}
      showMoreOffers={<PublisherMoreOffersContainer />}
    />
  );
};
